import React, { useState } from 'react'
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  TextField, 
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { saveFormDetails } from "../redux/slices/CreateAgentSlice";
import { FORM_KEYS } from '../utills/constant';

function AgentName({ open, onClose, onclick }) {
  const dispatch = useDispatch();
  const { deployAgentLoading } = useSelector((state) => state.DeploySlice);
  const { formDetails } = useSelector((state) => state.CreateAgentSlice);

  const [nameError, setNameError] = useState(false);

  const setFormDetailsValue = (key, value) => {
    dispatch(saveFormDetails({ key, value }));
    if (key === FORM_KEYS.NAME) {
      setNameError(value.trim() === '');
    }
  };

  const handleCreateAgent = () => {
    const nameValue = formDetails[FORM_KEYS.NAME]?.trim();
    if (!nameValue) {
      setNameError(true);
      return;
    }
    onclick(); // Proceed only if valid
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '50%',
          margin: 'auto',
          borderRadius: '15px'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: '15px'
        }}
      >
        <Button onClick={onClose} color='black'>
          <CancelOutlinedIcon fontSize='small' />
        </Button>
      </Box>

      <DialogContent>
        <Box className="input-directory-column">
          <Typography sx={{ color: '#4F4F4F', fontWeight: 'bold' }}>
            AGENT NAME
          </Typography>
          <TextField
            value={formDetails[FORM_KEYS.NAME]}
            placeholder="Enter Name"
            fullWidth
            className="input-directory-textfield"
            onChange={(event) => setFormDetailsValue(FORM_KEYS.NAME, event.target.value)}
            error={nameError}
            helperText={nameError ? 'Agent name is required' : ''}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          m: 1
        }}
      >
        <Button
          variant='outlined'
          onClick={onClose}
          sx={{
            color: '#828282',
            borderColor: '#828282',
            borderRadius: '18px',
            width: '35%'
          }}
        >
          CANCEL
        </Button>
        <Button
          onClick={handleCreateAgent}
          variant='contained'
          sx={{
            borderRadius: '18px',
            width: '35%',
            backgroundColor: '#3B5CFF'
          }}
        >
          {deployAgentLoading ? (
            <CircularProgress size={24} sx={{ color: '#fff' }} />
          ) : (
            'CREATE AGENT'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AgentName;
